export default __webpack_public_path__ + "static/media/team.3ff95145.svg";